import { mergeObjectTypes } from '../cacheHelpers';

const Delay = {
  merge: mergeObjectTypes
};

export default Delay;
